import styled from 'styled-components'

export const TableContainer = styled.div`
    overflow-x: auto;
    white-space: nowrap;

    &.active {
        padding-bottom: 80px;
    }

    .selected {
        background-color: #ebf3ff;
    }

    .table {
        width: calc(100% - 1px);

        thead {
            th {
                border: none;
                font-weight: 400;
            }
        }

        tbody {
            border-left: 1px solid #dee2e6;
            border-right: 1px solid #dee2e6;
            border-bottom: 1px solid #dee2e6;
            font-size: 0.85rem;
            font-weight: 300;

            tr {
                background-color: #fff;
                height: 56px;

                td {
                    vertical-align: middle;

                    img {
                        height: 30px;
                    }

                    .badge {
                        font-size: 90%;
                        font-weight: 400;
                    }
                }
            }
        }
    }
`

export const NoResultsContainer = styled.div`
    display: flex;
    flex-direction: column;
    justify-content: center;
    align-items: center;
    padding-top: 4rem;
    padding-bottom: 4rem;

    p {
        font-size: 1.1rem;
    }
`
